import React from 'react';
import { RosterItem } from '../../../../../app/domain/Roster/RosterItem';
import Input from '../../../misc/field/Input';

// Styles
import styles from './SelectInputMenu.module.css';

interface Props {
  columnCfg: any;
  onChange: (item: RosterItem, cfg: any) => void;
  onClick?: (e: React.MouseEvent) => void;
  onFocus: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  rosterItem: RosterItem;
}

const NumberInputColumn: React.FC<Props> = ({ columnCfg, onChange, onFocus, onBlur, rosterItem }) => {
  const errorMessage = rosterItem.errorMessage || {};

  return (
    <td className={columnCfg.id}>
      <Input
        className={errorMessage[columnCfg.id.toLowerCase()]?.length > 0 ? styles.border : ''}
        type="text"
        name="number_input"
        value={rosterItem[columnCfg.field]}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const value = e.target.value;
          if (value !== rosterItem[columnCfg.field]) {
            rosterItem[columnCfg.field] = value;
            onChange(rosterItem, columnCfg);
          }
        }}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyPress={(event: React.KeyboardEvent<HTMLInputElement>) => {
          if (!/-?([0-9]+([.][0-9]*)?|[.][0-9]+)/.test(event.key)) {
            event.preventDefault();
          }
        }}
      />
    </td>
  );
};

export default NumberInputColumn;
